/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import FormField from "components/FormField";
import SoftBox from "components/SoftBox";

export default function CreateUser({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { email } = formField;
  const { email: emailV } = values;

  return (
    <div>
      <SoftBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} style={{ paddingTop: "0px" }}>
            <FormField
              type={email.type}
              label={email.label}
              name={email.name}
              value={emailV}
              placeholder={email.placeholder}
              error={errors.email && touched.email}
              success={emailV.length > 0 && !errors.email}
              disabled={false}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </div>
  );
}
